import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { AccordionItemType } from "@swo/storefront";
import cn from "classnames";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../styles/styles-css-variables";

import { CSS_MQ } from "../../styles/breakpoints";
import { HotspotHr } from "../ProductClickAndInfoComponent/elements/HotspotHr";
import { FONTS } from "../../styles/fonts";
import { plainTextStyles } from "../../styles/text-styles";
import React from "react";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../domain/swarovski-optik/products/product-name/product-name-renderer";
import { SORichTextRenderer } from "../_shared-components/so-rich-text";
import { UpArrowSvg } from "../../assets";

export const AccordionElement: ReactTFC<{ ai: AccordionItemType; onClick: (() => void) | undefined }> = ({
  ai,
  onClick,
}) => {
  return (
    <div
      key={ai.descriptiveHeadline}
      className={cn(!onClick ? "active" : undefined)}
      css={css`
        border-bottom: 1px solid ${CSS_COLORS.Grey};
        position: relative;

        &:first-of-type {
          border-top: 1px solid ${CSS_COLORS.Grey};
        }
      `}
    >
      <button
        onClick={onClick}
        disabled={!onClick}
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          cursor: pointer;
          &:disabled {
            cursor: initial;
          }

          &:focus {
            outline: none;
          }
        `}
      >
        <h2 css={headlineStyles}>
          <EXPERIMENTAL_TextWithProductNameRenderer text={ai.descriptiveHeadline} />
        </h2>
        <UpArrowSvg css={chevronStyles} />
      </button>

      <div
        css={css`
          display: none;
          overflow: hidden;

          .active & {
            margin-top: -11px;
            ${CSS_MQ.atLeastMd} {
              margin-top: -9px;
            }

            display: block;
          }
        `}
      >
        <h3 css={emoHeadlineStyles}>
          <EXPERIMENTAL_TextWithProductNameRenderer text={ai.emoHeadline} />
        </h3>
        <HotspotHr />

        <section
          css={[
            FONTS.SwarovskiFutura300,
            plainTextStyles,
            css`
              color: ${CSS_COLORS.Black};

              margin-top: 17px;
              margin-bottom: 17px;

              @media (min-width: 42em) {
                max-width: 38em;
              }
            `,
          ]}
        >
          <SORichTextRenderer richText={ai.richText} options={"default"} />
        </section>
      </div>
    </div>
  );
};

const chevronStyles = css`
  flex-shrink: 0;

  width: 16px;
  ${CSS_MQ.atLeastMd} {
    width: 20px;
  }

  color: black;

  transform: rotate(90deg);
  transition: transform 0.3s;

  .active & {
    transform: rotate(180deg);
  }
`;

const headlineStyles = css`
  text-align: left;

  padding-top: 16px;
  padding-bottom: 15px;
  ${CSS_MQ.atLeastMd} {
    padding-top: 18px;
    padding-bottom: 17px;
  }

  ${FONTS.SwarovskiFutura500};
  font-size: 16px;
  line-height: 1;
  color: ${CSS_COLORS.Black};
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 0;

  letter-spacing: 0.8px;
  ${CSS_MQ.atLeastMd} {
    letter-spacing: 1px;
  }
`;

const emoHeadlineStyles = css`
  ${FONTS.MinervaModern500};
  color: ${CSS_COLORS.Green};
  text-transform: uppercase;
  margin-bottom: 15px;
  margin-top: 0;

  font-size: 21px;
  letter-spacing: 0.35px;
  line-height: 26px;

  ${CSS_MQ.atLeastMd} {
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 1.5px;
  }
`;
